module.exports = __webpack_public_path__ + "img/m_banner02_gobal visibility-e.2ce6f3eb.jpg";